import RequestAbstract from "./RequestAbstract";

export default class Stripe extends RequestAbstract {
    get link() {
        return this.links.stripe;
    }

    get invoices() {
        return this.link + "/invoice/";
    }

    async success(resp) {
        return await this.post(this.link + "/success", resp);
    }

    async freeVersion() {
        return await this.post(this.link + "/free-subscription");
    }

    async failed(resp) {
        return await this.post(this.link + "/failed?error=true", resp);
    }

    async invoice(id) {
        return await this.get(this.invoices + id);
    }

    async cancelSubscription(resp) {
        return await this.post(this.link + "/cancel-subscription", resp);
    }
}